// @ts-strict-ignore
import { NavigationContent } from '@lib/kontent/navigation-helpers/normalize-navigation-content'
import { useTranslation } from 'next-i18next'
import { FC, useState } from 'react'
import Subrow from '../Subrow'
import { SUBROW_HEIGHT_MEDIUM, SUBROW_HEIGHT_SMALL } from '../utils/config'
import { getSubrowAnimation } from '../utils/get-subrow-animation'
import { useResponsiveRowHeight } from '../utils/useResponsiveRowHeight'
import { Jewelry } from './Jewelry'
import { Watches } from './Watches'
import { Service } from './Service'

type Props = {
  content: NavigationContent
}

const PreOwned: FC<Props> = ({ content }) => {
  const [active, setActive] = useState(null)
  const rowHeight = useResponsiveRowHeight(SUBROW_HEIGHT_SMALL, SUBROW_HEIGHT_MEDIUM)
  const margin = useResponsiveRowHeight(0, 16)
  const { t } = useTranslation('dropdown')
  const toggle = (index) => setActive(index === active ? null : index)
  return (
    <>
      <Subrow
        isActive={active === 0}
        label={t('preowned.watches')}
        onClick={() => toggle(0)}
        {...getSubrowAnimation({ index: 0, active, height: rowHeight, margin })}
      >
        <Watches {...content.preOwnedWatches} />
      </Subrow>
      <Subrow
        isActive={active === 1}
        label={t('preowned.jewels')}
        onClick={() => toggle(1)}
        {...getSubrowAnimation({ index: 1, active, height: rowHeight, margin })}
      >
        <Jewelry {...content.preOwnedJewels} />
      </Subrow>
      <Subrow
        isActive={active === 2}
        label={t('preowned.service')}
        onClick={() => toggle(2)}
        {...getSubrowAnimation({ index: 2, active, height: rowHeight, margin })}
      >
        <Service {...content.preOwnedJewelsService} />
      </Subrow>
    </>
  )
}

export default PreOwned
